export function initialsFromName(name: string): string {
  const initials = name
    .split(' ')
    .filter(Boolean)
    .map((part) => part[0]!.toUpperCase())
    .slice(0, 2)
    .join('')
  return initials || '??'
}
